// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3xWYP","list":"PatternAutocomplete_list__1rbXd"};